import { stage as stageEnum } from '../enums';
import { newLine } from '../../components/API/API';
import { ILine } from '../../global';

export async function createNewLine(line: ILine) {
  const lineRes = await newLine(
    line.name,
    line.product,
    line.inventory,
    line.stages.map(({ name, start, amount, deleted }, order) => ({
      name,
      start,
      amount,
      deleted,
      order,
    })),
  );

  const updatedStages = lineRes.newStages.filter(
    (stage) =>
      stage.name !== stageEnum.repaymentsStart.value &&
      stage.name !== stageEnum.complete.value,
  );
  return { id: lineRes.id, stages: updatedStages };
}
